import { render } from "./Number.vue?vue&type=template&id=bac2f056&scoped=true"
import script from "./Number.vue?vue&type=script&lang=ts"
export * from "./Number.vue?vue&type=script&lang=ts"

import "./Number.vue?vue&type=style&index=0&id=bac2f056&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-bac2f056"

export default script